import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const SelectContainer = styled.div`
  position: relative;
  width: 200px;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.inset};
  color: ${tokens.text.muted};
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const SelectInput = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: ${tokens.text.primary};
  font-size: 1rem;
`

export const SelectOptionsContainer = styled.div`
  position: fixed;
  left: 0;
  width: fit-content;
  max-height: 200px;
  background: ${tokens.surface.raised};
  color: ${tokens.text.primary};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  box-shadow: ${tokens.shadow.card};
  z-index: 100000;
  overflow-y: auto;

  // overflow scrollbar
  &::-webkit-scrollbar {
    display: none;
  }
  & {
    scrollbar-width: none;
  }
  & {
    -ms-overflow-style: none;
  }
`

export const SelectOption = styled.div<{ active?: boolean }>`
  padding: 8px;
  cursor: pointer;
  color: ${(props) => (props.active ? tokens.accent.onDark : tokens.text.primary)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    background: ${tokens.surface.inset};
  }
`

export const SelectLabel = styled.div`
  color: ${tokens.text.primary};
  position: absolute;
  line-height: 2.5rem;
  top: 0;
  bottom: 0;
  left: 16px;
  right: 40px;
  z-index: 100;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-block: auto;
`

export const ChevronIconContainer = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  height: 1.5rem;
  color: ${tokens.text.secondary};
`

export const MultiSelectFieldWrapper = styled.div<{ invalid?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  overflow: hidden;
  min-width: 0;

  width: 100%;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  padding: 0.5rem 1rem;
  padding-right: 2.5rem;
  background: ${tokens.surface.inset};

  min-height: 44px;
  cursor: text;

  &:focus-within {
    border: 1px solid ${tokens.accent.base};
  }

  ${(props) =>
    props.invalid &&
    `
    border: 1px solid ${tokens.status.danger.fg};
  `}
`

export const MultiSelectInput = styled.input`
  border: none;
  outline: none;
  min-width: 0;
  width: 0;
  flex: 1 1 150px;
  background: transparent;
  color: ${tokens.text.primary};
  font-size: 1rem;
`

export const Pill = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  background: ${tokens.accent.soft};
  color: ${tokens.accent.onDark};
  font-size: 0.85rem;
`

export const Remove = styled.span`
  cursor: pointer;
`
